import { Feature } from './feature.model';
import { Exclude, Expose, Transform } from 'class-transformer';
import { boolTransform, dateTransform } from 'elbuild-ui-lib-core';

export class Role {
	id: number;
	rolename: string;
	description: string;

	@Transform(boolTransform)
	sudo: boolean = false;


	@Transform(boolTransform)
	@Expose({ name: 'editable' })
	adminrole: boolean = true;

	@Exclude({ toPlainOnly: true })
	slug: string;

	// "transient" fields
	@Exclude()
	features: RoleFeature[];
	@Exclude()
	showdetails: boolean;

	@Transform(dateTransform)
	insdate: number;

	@Transform(dateTransform)
	moddate: number;


}

export class UserToRole {
	id: number;
	rid: number;
	uid: number;
	@Transform(dateTransform)
	insdate: number;
}

export class RoleFeature {
	id: number;
	rid: number;
	fid: number;
	feature: Feature;
}

export enum RoleSlug {
	ADMIN = 'admin',
	SUPER_ADMIN = 'superadmin',
}

export function role() {
	return Role;
}
